export var BUFFER_CONFIG = {
    eventsBufferSize: 32,
    eventsBufferTimeout: 20000,
    eventsBufferEnabled: true,
};
export var SESSION_INVALIDATE_TIMEOUT = 120 * 1000;
export var EVENTS_BUFFER_STORAGE_KEY = '[saykit] events-buffer';
export var REMOTE_CONFIG_KEY = 'remote-config';
export var FEATURE_FLAGS = {
    onboarding_tutorial: 0,
    keyword_ab_test_group: '',
    banners: 'default',
    interstitials: 'default',
    deeplink: 0,
    deeplink_text: 1,
};
export var DEFAULT_REMOTE_CONFIG = {
    runtime: {
        country: 'BY',
        segment: 0,
    },
    game_settings: FEATURE_FLAGS,
};
//# sourceMappingURL=constants.js.map